import { defaultBorderRadiusScale, defaultColorTokens, defaultFontSizeScale, defaultFontTokens, defaultLetterSpacingScale, defaultLineHeightScale, defaultSpacingScale, defaultTransitionDurationTokens, defaultTransitionFunctionTokens } from './defaultTokens';
export const DefaultTwistTheme = {
    screens: {
        sm: 480,
        lg: 960,
        xl: 1440,
        max: 1920
    },
    scales: {
        borderRadius: defaultBorderRadiusScale,
        fontSize: defaultFontSizeScale,
        lineHeight: defaultLineHeightScale,
        letterSpacing: defaultLetterSpacingScale,
        spacing: defaultSpacingScale
    },
    tokens: {
        fonts: defaultFontTokens,
        transitionDurations: defaultTransitionDurationTokens,
        transitionFunctions: defaultTransitionFunctionTokens,
        colors: defaultColorTokens
    },
    defaults: {
        TwistGridItem: {
            colSpan: {
                min: 4,
                lg: 12
            }
        },
        TwistGrid: {
            cols: {
                min: 4,
                lg: 12
            },
            colGaps: [
                ['min', 30],
                ['sm', 'lg', 30, 60],
                ['lg', 'max', 45, 90],
                ['max', 90]
            ],
            rowGaps: []
        }
    }
};
